// extracted by mini-css-extract-plugin
export default {"wrapper":"multiSelect_wrapper__oWOat","openMultiSelect":"multiSelect_openMultiSelect__tF1rG","animateIn":"multiSelect_animateIn__IacLq","option":"multiSelect_option__NZi5B"};